import { render } from "./FaceUsedNumber.vue?vue&type=template&id=65437b92&scoped=true"
import script from "./FaceUsedNumber.vue?vue&type=script&lang=js"
export * from "./FaceUsedNumber.vue?vue&type=script&lang=js"

import "./FaceUsedNumber.vue?vue&type=style&index=0&id=65437b92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65437b92"

export default script